import { useEffect } from "react";
import { Outlet, useParams, useLocation } from "react-router-dom";
import NavMain from "../components/NavMain";
import Footer from "../components/Footer";

const LayoutRoot = () => {
  const page = useParams();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <main>
      <NavMain />
      <div>
        <Outlet />
      </div>
      {page.itemId ? "" : <Footer />}
    </main>
  );
};

export default LayoutRoot;
